import React, { useEffect } from "react";
import { pubCall } from "../utils/PubSub";
import { KBD } from "../utils/Keybindings";
import Alert from "../ui/Alert";
import dayjs from "dayjs";
import { ROUTES } from "../utils/Routes";
import Cookies from "js-cookie";
import TextButton from "../ui/TextButton";
export default function Maintenance(props) {
    const { route = "", callback = () => { } } = props;

    useEffect(() => {

        if (!window.bm_state.value === ROUTES.GLOBAL.MAINTENANCE) {
            return;
        }
        const intervalId = setInterval(() => {
            pubCall("extra.ping", { time: dayjs().unix() }, () => { });
        }, 30000); // Update every second
        return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);

    const changeLocation = () => {
        Cookies.set("workstation", null, { expires: 14 })
        window.history.replaceState(null, '', '/');
        window.location.reload();
    }

    // Backup is in queue/processing 
    // Store is in maintenance mode
    // Store removed from processing

    let notice = <>Bookmanager is currently set to <strong>maintenance mode</strong>, and all current functions are temporarily unavailable. <div className="shim" /><div className="shim" /><div className="shim" /></>;


    let color = "var(--text-orange)";
    let message;
    switch(props.res?.kwargs?.message){
        case "Backup is in queue/processing":
            color = "var(--text-olive)"
            message = <>Your backup is currently being processed. Please wait as we work on importing. It should only take a few minutes. <div className="shim" /><div className="shim" /><div className="shim" /></>;

        break; 
        case "Store is in maintenance mode":
            color = "var(--text-orange)"
            message = <>Oh no, something seems to have gone wrong! Please send a backup in order to use BMO again. If this keeps happening, please contact Bookmanager support for assistance. <div className="shim" /><div className="shim" /><div className="shim" /></>;

        break; 
        case "Store removed from processing":
            color = "var(--text-red)"
            message = <>Oh shoot, something went wrong! Please contact Bookmanager support to help resolve this issue. <div className="shim" /><div className="shim" /><div className="shim" /></>;
        break; 
        default:

    }

    
    return (
        <div style={{ "width": "500px" }}>
            <div className="shim" /><div className="shim" />
            <Alert
                color={color}
                title="Maintenance mode."
                description={<>{notice}{message}
                    <TextButton kbd={KBD.ESCAPE} onClick={() => changeLocation()} disabled type="secondary">Change Location</TextButton>
                </>}
            />
        </div>
    )


}
